import React from 'react';
import { Box } from '@mui/material';
import EventDetails from './EventDetails';

interface EventInfoProps {
  event: any;
}

const EventInfo: React.FC<EventInfoProps> = ({ event }) => {
  const { title, images, start_at, end_at, timezone, sessions, organization, organization_mentions } = event;
  const mainImage = images.find(({ main }: any) => main);

  return (
    <Box sx={{ padding: '12px', borderRadius: '8px', backgroundColor: '#F5F6FA' }}>
      <EventDetails
        eventImage={mainImage?.image?.original_url || ''}
        eventTitle={title}
        startAt={start_at}
        endAt={end_at}
        timeZone={timezone}
        sessions={sessions}
        organization={organization}
        hosts={organization_mentions}
      />
    </Box>
  );
};

export default EventInfo;
